import { h, Component } from 'preact';
import pure from 'utils/pure';
import { Link } from 'components/core/link/link';
import s from 'components/shared/theaters/homeEnt.sss';


export default @pure class HomeEnt extends Component {

	render({ appData }) {
		const { copy } = appData;
		const showtimes = appData.pages.showtimes;
		const homeEnt = showtimes.data.homeEnt || {};
		const linkProps = {};

		const {
			url,
			title: homeEntTitle,
			text: homeEntText,
			pageId
		} = homeEnt;

		if (url) {
			// Direct to a new url
			linkProps.href   = url;
			linkProps.target = '_blank';
		}

		if (pageId) {
			// Let's direct to a page
			linkProps.pageId = pageId;
		}

		const title     = copy[homeEntTitle || '$CTA_HOME_ENT'];
		const linkLabel = copy[homeEntText || '$HOME_ENT_TEXT'];

		return (
			<div class={s.wrapper}>
				{title && (
					<h3 class={s.title}>
						{title}
					</h3>
				)}
				<Link
					class={s.cta}
					{...linkProps}>
					{linkLabel}
				</Link>
			</div>
		);
	}

}
